import React from 'react';
import { FadeIn, Section, FloralSeparator } from '../ui/Shared';
export const ProductPresentation = () => <Section className="bg-cream" data-id="element-131" data-mp="3frrhf2unu67u">
    <div className="grid lg:grid-cols-2 gap-8 items-center" data-id="element-132" data-mp="3fqgaiu5x4ici">
      <FadeIn data-id="element-133" data-mp="3ug5hj60ozgkp">
        <p className="italic text-brown-text/70 mb-2" data-id="element-134" data-mp="3ueugvf2jmoxt">Presentando:</p>
        <h1 className="text-5xl md:text-6xl font-bold text-pink-deep mb-4" data-id="element-135" data-mp="3ph15m7mdv4qo">
          🌸 RENACER DESPUÉS DEL PARTO
        </h1>
        <h2 className="text-2xl italic text-celeste-deep mb-6 font-heading" data-id="element-136" data-mp="31s9qagtw6gvb">
          El método paso a paso para recuperar tu estabilidad emocional, tu
          descanso y tu paz interior — en 4 semanas.
        </h2>

        <div className="border-l-4 border-pink-border pl-6 space-y-3 mb-6" data-id="element-137" data-mp="3atg3oh18vbkc">
          <p className="font-bold" data-id="element-138" data-mp="36p8dsgj1vpkj">
            Un proceso completo, amoroso y estructurado.
          </p>
          <p className="font-bold" data-id="element-139" data-mp="q0cot2fcnsnd">
            Diseñado específicamente para madres en el postparto.
          </p>
          <p className="font-bold" data-id="element-140" data-mp="lzsue6m5v34x">
            Para que no tengas que atravesarlo sola, a ciegas o improvisando.
          </p>
        </div>

        <p className="mb-3 font-medium" data-id="element-141" data-mp="2mg6sgri3plkl">
          Con Renacer Después del Parto vas a tener:
        </p>
        <ul className="space-y-2 mb-6" data-id="element-142" data-mp="2qhikf3og6ivy">
          {['Un camino claro, organizado por etapas emocionales', 'Herramientas prácticas para los momentos difíciles', 'Material listo para usar cuando la ansiedad aparece', 'La certeza de que lo que sentís tiene explicación y solución', 'Un proceso que podés hacer a tu ritmo, desde tu casa, cuando puedas'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-143" data-mp="22qd46nelhol4" data-mpi={i}>
              <span className="text-pink-primary mt-1" data-id="element-144" data-mp="27qhmmiz2ctdz">✦</span>
              <span data-id="element-145" data-mp="2ci93u2wbxmrg">{item}</span>
            </li>)}
        </ul>

        <p className="text-2xl italic font-heading text-pink-deep font-bold" data-id="element-146" data-mp="2cjk6u0hyaqhi">
          Primero comprendés. Después sanás. Finalmente, renacés.
        </p>
      </FadeIn>

      <FadeIn delay={0.2} className="relative" data-id="element-147" data-mp="1k0wr70lq43nt">
        <div className="absolute inset-0 bg-gradient-to-tr from-pink-light to-celeste-light rounded-3xl transform rotate-3 scale-105 -z-10" data-id="element-148" data-mp="1jzlm8xgjkpv4"></div>
        <img src="https://cdn.magicpatterns.com/uploads/uRf3NDZHdwbat5tQQ2nVPJ/WhatsApp_Image_2026-03-15_at_17.08.59_(2).jpg" alt="Renacer Después del Parto Tomos" className="rounded-3xl shadow-2xl w-full object-cover" data-id="element-149" data-mp="2iekdtmbz1xws" />
      </FadeIn>
    </div>
  </Section>;
export const TomosSection = () => <Section className="bg-white" data-id="element-150" data-mp="24dhvnko3l7r5">
    <FadeIn data-id="element-151" data-mp="24ejfoen3d4l0">
      <h2 className="text-4xl md:text-5xl text-center mb-10 italic" data-id="element-152" data-mp="24e9m6h2u8fak">
        ¿Qué vas a recibir?
      </h2>
    </FadeIn>

    <div className="grid lg:grid-cols-2 gap-6" data-id="element-153" data-mp="2deocjuunskkx">
      {/* Tomo 1 */}
      <FadeIn delay={0.1} data-id="element-154" data-mp="2dfzgbuo3tsc1">
        <div className="bg-pink-light border border-pink-border rounded-3xl p-6 md:p-8 h-full flex flex-col" data-id="element-155" data-mp="28fl5y5z166au">
          <div className="mb-6 text-center" data-id="element-156" data-mp="3otl2d6yo3dtc">
            <h3 className="text-3xl font-bold text-pink-deep mb-2" data-id="element-157" data-mp="3osjutcgv19gd">
              🌸 TOMO I
            </h3>
            <h4 className="text-2xl italic text-brown-text font-heading mb-2" data-id="element-158" data-mp="3ju8kz1qkeyy5">
              "No Estás Sola"
            </h4>
            <p className="text-pink-deep font-medium" data-id="element-159" data-mp="3se529ip9af41">
              Comprensión y estabilización emocional
            </p>
          </div>

          <div className="space-y-3 mb-6 text-brown-text/90 italic" data-id="element-160" data-mp="3iee9blgcg862">
            <p data-id="element-161" data-mp="3nco07jv1cmlv">Este primer tomo te abraza en el momento más difícil.</p>
            <p data-id="element-162" data-mp="3nes4i2wujnmo">Cuando todavía no entendés bien qué está pasando.</p>
            <p data-id="element-163" data-mp="ey73p9edc0un">Cuando la culpa y el agotamiento son lo que más sentís.</p>
            <p data-id="element-164" data-mp="jwgxpgocwveo">
              Cuando necesitás que alguien te diga:{' '}
              <span className="font-bold" data-id="element-165" data-mp="572p4aslui0c">
                "Lo que sentís es real, tiene nombre y tiene salida."
              </span>
            </p>
          </div>

          <p className="font-bold mb-3" data-id="element-166" data-mp="a4l1kb5tzfd3">Dentro vas a encontrar:</p>
          <ul className="space-y-2 mb-6 flex-grow" data-id="element-167" data-mp="xvgmqpfs7cbd">
            {['Explicación clara de la depresión postparto y los cambios hormonales', 'Diferencias entre baby blues y depresión postparto — entendé en qué punto estás', 'Validación emocional profunda — dejá de sentirte "defectuosa"', 'Primeras herramientas para manejar la ansiedad y los desbordes', 'Ejercicios de respiración y reflexión que podés hacer hoy', 'Cómo pedir ayuda y empezar a construir tu red de apoyo'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-168" data-mp="2w6ig8m7w6bqb" data-mpi={i}>
                <span className="text-pink-primary mt-1" data-id="element-169" data-mp="2w83b6cy4bwop">🌸</span>
                <span data-id="element-170" data-mp="3tszb7kt5kd8w">{item}</span>
              </li>)}
          </ul>

          <div className="bg-white/60 p-5 rounded-xl border border-pink-border/50 mt-auto" data-id="element-171" data-mp="3ov68j1r261dd">
            <p className="font-bold text-pink-deep" data-id="element-172" data-mp="3k47ops6v2l5d">
              🎯 Al terminar el Tomo I vas a entender exactamente qué te está
              pasando — y vas a dejar de sentirte sola en esto.
            </p>
          </div>
        </div>
      </FadeIn>

      {/* Tomo 2 */}
      <FadeIn delay={0.2} data-id="element-173" data-mp="gh7ck0436fzv">
        <div className="bg-celeste-light border border-celeste-primary/30 rounded-3xl p-6 md:p-8 h-full flex flex-col" data-id="element-174" data-mp="bonzr5d83ow4">
          <div className="mb-6 text-center" data-id="element-175" data-mp="j0c5227rvhy6">
            <h3 className="text-3xl font-bold text-celeste-deep mb-2" data-id="element-176" data-mp="j1n81zte8lo8">
              💙 TOMO II
            </h3>
            <h4 className="text-2xl italic text-brown-text font-heading mb-2" data-id="element-177" data-mp="o0gljs8okcoe">
              "Sanación Profunda"
            </h4>
            <p className="text-celeste-deep font-medium" data-id="element-178" data-mp="xxcn1e05vyjg">
              Transformación y reconstrucción del equilibrio
            </p>
          </div>

          <div className="space-y-3 mb-6 text-brown-text/90 italic" data-id="element-179" data-mp="11y4xuboombhu">
            <p data-id="element-180" data-mp="16wg8upqpqs1n">Este segundo tomo te guía hacia la reconstrucción.</p>
            <p data-id="element-181" data-mp="1bohn2h7fysub">
              Cuando ya entendés lo que viviste y estás lista para sanar de
              verdad.
            </p>
            <p data-id="element-182" data-mp="1gm9jnoj1734u">
              Cuando querés recuperar tu autoestima, tu identidad y tu calma.
            </p>
            <p data-id="element-183" data-mp="1lnyub32cdese">
              Cuando necesitás herramientas concretas para tu día a día como
              mamá.
            </p>
          </div>

          <p className="font-bold mb-3" data-id="element-184" data-mp="3momzzim5g7ud">Dentro vas a encontrar:</p>
          <ul className="space-y-2 mb-6 flex-grow" data-id="element-185" data-mp="3mov9r1mz6x1c">
            {['Trabajo sobre creencias limitantes y autoexigencia materna', 'Reconexión con tu cuerpo y regulación del sistema nervioso', 'Ejercicios para fortalecer el vínculo con tu bebé — sin presión', 'Diseño de rutinas mínimas que devuelven estabilidad', 'Estrategias para establecer límites y pedir apoyo con seguridad', 'Plantillas prácticas y rituales diarios que realmente funcionan'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-186" data-mp="4b5me76qpcrz" data-mpi={i}>
                <span className="text-celeste-deep mt-1" data-id="element-187" data-mp="4d07bli0h4w2">💙</span>
                <span data-id="element-188" data-mp="i93uwvydqezk">{item}</span>
              </li>)}
          </ul>

          <div className="bg-white/60 p-5 rounded-xl border border-celeste-primary/30 mt-auto" data-id="element-189" data-mp="e8acuj7mbuel">
            <p className="font-bold text-celeste-deep" data-id="element-190" data-mp="2k18mu7fvpcaa">
              🎯 Al terminar el Tomo II vas a sentir que recuperaste el control
              de tu vida emocional — y que volviste a ser vos.
            </p>
          </div>
        </div>
      </FadeIn>
    </div>

    <FadeIn delay={0.4} className="text-center mt-10" data-id="element-191" data-mp="25ym44h4olzqu">
      <FloralSeparator data-id="element-192" data-mp="29wjtbjygclu8" />
      <p className="text-xl italic font-heading text-pink-deep font-bold" data-id="element-193" data-mp="29x1w6zfmdyb4">
        ✨ Juntos, los dos tomos forman un proceso completo de 4 semanas:
        <br data-id="element-194" data-mp="214zyh8wxqw4j" />
        Comprendés → Sanás → Renacés
      </p>
    </FadeIn>
  </Section>;
export const ResultsSection = () => {
  const results = [{
    icon: '🌊',
    title: 'Estabilidad emocional real',
    desc: 'Dejarás de sentir que vivís en una montaña rusa. Vas a entender tus emociones y gestionarlas con calma.'
  }, {
    icon: '🌙',
    title: 'Descanso que se recupera',
    desc: 'Herramientas prácticas para relajar tu mente, reducir la ansiedad nocturna y volver a dormir.'
  }, {
    icon: '🤍',
    title: 'La culpa que se va',
    desc: 'Vas a dejar de castigarte por no sentirte "perfecta". Lo que te pasa tiene explicación — y solución.'
  }, {
    icon: '💪',
    title: 'Autoestima renovada',
    desc: 'Te vas a sentir más capaz, más segura y más conectada con tu rol de mamá — sin perder quien sos.'
  }, {
    icon: '🧠',
    title: 'Ansiedad bajo control',
    desc: 'Recursos concretos para cuando aparezcan los momentos difíciles. Vas a saber qué hacer.'
  }, {
    icon: '🌸',
    title: 'Tu identidad, de vuelta',
    desc: 'No sos solo mamá. Este proceso te ayuda a reencontrarte con vos misma — con la mujer que seguís siendo.'
  }, {
    icon: '👶',
    title: 'Vínculo más profundo',
    desc: 'Al sentirte más estable emocionalmente, vas a poder estar más presente — y disfrutar más la maternidad.'
  }, {
    icon: '🕊️',
    title: 'Paz interior',
    desc: 'Esa sensación de calma que hoy parece tan lejana — vuelve. Paso a paso. A tu ritmo.'
  }];
  return <Section className="bg-cream" data-id="element-195" data-mp="1qotnlo620tee">
      <FadeIn data-id="element-196" data-mp="1qnsdpn0rycy9">
        <h2 className="text-4xl md:text-5xl text-center mb-10 italic" data-id="element-197" data-mp="1qoahr5tohvgq">
          Lo que va a cambiar en tu vida
        </h2>
      </FadeIn>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5" data-id="element-198" data-mp="34ld53ilkc7hu">
        {results.map((res, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-199" data-mp="39k7ytfl2jggq" data-mpi={i}>
            <div className={`p-5 rounded-2xl h-full border ${i % 2 === 0 ? 'bg-pink-light/50 border-pink-border' : 'bg-celeste-light/50 border-celeste-primary/30'} hover:-translate-y-1 transition-transform duration-300`} data-id="element-200" data-mp="39j6d8h6ffbkr">
              <div className="text-4xl mb-3" data-id="element-201" data-mp="3ibqc9iqmri64">{res.icon}</div>
              <h3 className="text-xl font-bold text-pink-deep mb-2 font-heading leading-tight" data-id="element-202" data-mp="2ln0wpz2h71nb">
                {res.title}
              </h3>
              <p className="text-sm text-brown-text/80" data-id="element-203" data-mp="2qlltfoiir370">{res.desc}</p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};